
<div class="mat-simple-snackbar">
    <span *ngIf="!id">{{mensagem}}</span>
    <div class="mat-simple-snackbar-action">
      <button mat-button (click)="close()"> x </button>
    </div>
  </div>
  